import { useStaticQuery, graphql } from 'gatsby';

type SiteMetadata = Queries.Query['site']['siteMetadata'];
type SiteCommon = Queries.Query['allCommonModules']['edges'][number]['node'];

const useLayoutQuery = (): {
    metaData: SiteMetadata;
    common: SiteCommon;
} => {
    const { site, allCommonModules } = useStaticQuery<{
        site: Queries.Query['site'];
        allCommonModules: Queries.Query['allCommonModules'];
    }>(graphql`
        {
            site {
                siteMetadata {
                    language
                }
            }
            allCommonModules {
                edges {
                    node {
                        cookie_policy {
                            language {
                                information
                                cta
                                moreInfoLink
                            }
                            moreInfoLinkUrl
                            enabled
                        }
                        app_store {
                            appleStoreToggle
                            appStoreUrl
                            googleStoreToggle
                            googlePlayUrl
                        }
                    }
                }
            }
        }
    `);

    return { metaData: site.siteMetadata, common: allCommonModules.edges[0].node };
};

export default useLayoutQuery;
